import { useEffect, useState } from "react";
import ServiceConfiguratorBlock from "./ServiceConfiguratorBlock";
import {FormattedMessage} from "react-intl";
import useGetServiceConfiguration from "@hooks/useGetServiceConfiguration";
import useCountryAxiosInstance from "@hooks/useCountryAxiosInstance";


const ServiceConfiguratorBlocksList = ({ data, service, ...props }) => {
  const countryApiRequest = useCountryAxiosInstance();
  const getServiceConfiguration = useGetServiceConfiguration(true);
  const steps_and_services = data.filter((s) => (
    s.type === "step" &&
    s.service_id === service.id
  ) || s.type === "service");
  // const [otherServicesData, setOtherServicesData] = useState([]);

  if (!steps_and_services || steps_and_services.length === 0)
    return <div className="flex items-center justify-center rounded-2xl bg-gray-100 w-full h-40">
      <FormattedMessage id="steps_empty_list_message" />
    </div>

  const getList = (s) => {
    switch(s.type) {
      case 'step':
        return data.filter((row) => row.step_id === s.id);
      case 'service':
        return data.filter(
          (row) =>
            row.service_id === s?.metadata_?.chosen_service_id &&
            row.type === 'step'
        );
      default:
        return [];
    }
  }



  return (
    <div className="w-full flex flex-col">
      {steps_and_services.map((s, index, self) => (
          <ServiceConfiguratorBlock
            key={s.id}
            position={index}
            listLength={self.length}
            block={s}
            blockType={s.type}
            list={getList(s)}
            data={data}
            service={service}
            {...(s.type === 'service' ? { serviceBlockId: s.id } : {})}
            {...props}
          />
        ))}
    </div>
  );
};

export default ServiceConfiguratorBlocksList;
